import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
// import logo1 from '../Image/logo1.png'
import { Link } from 'react-router-dom'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import axios from 'axios'
import { API_BASE_URL } from '../../../utils/auth';
import College from './College.js'
function CollegeListss() {
    // ***************************** user Authentication *******************************

    const [collegeChoise, setCollegeChoice] = useState([])
    const [studentData, setStudentData] = useState({});
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedCollege, setSelectedCollege] = useState(null);
    const [collegePrograms, setCollegePrograms] = useState([]);
    const [detailsLoading, setDetailsLoading] = useState(false);
    const [detailsError, setDetailsError] = useState('');
    const pageRef = useRef(1);
    const hasMoreRef = useRef(true);
    const loadingRef = useRef(false);
    const loader = useRef(null);
    const Navigate = useNavigate()

    const callStudentDashboardPage = async () => {
        try {
            const res = await fetch('/student-dashboards',
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    credentials: "include"
                }
            )
            const data = await res.json()
            // console.log(data)
            setStudentData(data)

            if (!res.status === 401) {
                const error = new Error(res.server)
                throw error;
            }
        } catch (error) {
            // console.log("unouthorized")
            Navigate('/login')
        }
    }

    // useEffect(() => {
    //     callStudentDashboardPage()
    // }, [])
    // console.log(collegeChoise)


    // ***********************************college choice *********************************
    const [state, setState] = React.useState(' ');
    const [programme, setProgramme] = React.useState('Engineering ( B-Tech / B.E )');
    const [collegeData, setCollegeData] = React.useState([])
    const [prog, setProg] = React.useState("")
    const [branch, setBranch] = React.useState("")
    const [loading, setLoading] = useState(false);
    const [programmes] = useState([
        "Engineering ( B-Tech / B.E )",
        "MBA / PGDM",
        "BBA",
        "BCA",
        "Bio Technology ( Bsc. BioTechnology / B-Tech BioTechnology )",
        "B.Pharmacy",
        "Agriculture ( Bsc. Agriculture / B-Tech Agriculture )",
        "Aeronautical / Aerospace Engineering",
        "Bsc Datascience",
        "Bsc.Nursing",
        "Bsc.Agriculture",
        "BPT ( Bachelor of Physiotherapy )",
        "B.Design",
        "LLB (BA / B.Com / B.sc / BBA / BCA)",
        "Mass Communication & Journalism"
    ]);
    const [indianStates] = useState([
        "Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar",
        "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi",
        "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir", "Jharkhand",
        "Karnataka", "Kerala", "Ladakh", "Lakshadweep", "Madhya Pradesh", "Maharashtra",
        "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry", "Punjab",
        "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh",
        "Uttarakhand", "West Bengal"
    ]);
    const [branches, setBranches] = useState([]);

    const fetchBranches = async (type) => {
        if (!type) {
            setBranches([]);
            return;
        }
        try {
            // Encode the type to handle special characters like / and ( )
            const encodedType = encodeURIComponent(type);
            const response = await axios.get(`/api/v1/front/programs/type/${encodedType}`);
            if (response.data.status == 200) {
                const data = response.data.data;
                const branchArray = Array.isArray(data) ? data : (data && Array.isArray(data.branches) ? data.branches : []);
                setBranches(branchArray);
            }
        } catch (error) {
            console.error('Error fetching branches:', error);
        }
    };

    useEffect(() => {
        if (programme) {
            fetchBranches(programme);
            setBranch(""); // Reset branch when programme changes
        }
    }, [programme]);

    // console.log(state)
    // console.log(collegeData)


    // **************************** COLLEGE SEARCH ********************************

    const [selectBranch, setSelectBranch] = React.useState("")
    const handleSubmit = useCallback(async (event, isLoadMore = false) => {
        if (event && event.preventDefault) {
            event.preventDefault();
        }

        if (isLoadMore && !hasMoreRef.current) {
            return;
        }

        const LIMIT = 15;
        const currentPage = isLoadMore ? pageRef.current + 1 : 1;

        try {
            loadingRef.current = true;
            setLoading(true);

            const params = {
                state: state === ' ' || state === 'All States' ? '' : state,
                branchType: programme === 'None' || !programme ? '' : programme,
                branch: branch === 'None' || !branch ? '' : branch,
                page: currentPage,
                limit: LIMIT,
                hideUnlisted: true,
            };

            const response = await axios.get(`/api/v1/front/colleges/summary`, { params, headers: { 'Cache-Control': 'no-cache' } });

            if (response.data.status == 200) {
                const data = response.data.data;
                const collegesArray = Array.isArray(data) ? data : (data && Array.isArray(data.colleges) ? data.colleges : []);

                if (isLoadMore && collegesArray.length === 0) {
                    setHasMore(false);
                    hasMoreRef.current = false;
                    return;
                }

                if (!isLoadMore) {
                    setCollegeData(collegesArray);
                    setPage(1);
                    pageRef.current = 1;
                    if (collegesArray.length === 0) {
                        setHasMore(false);
                        hasMoreRef.current = false;
                    }
                } else {
                    setCollegeData(prev => [...prev, ...collegesArray]);
                    setPage(currentPage);
                    pageRef.current = currentPage;
                }

                const totalPages = data?.totalPages || data?.pages || 0;
                const newHasMore = totalPages > 0 ? currentPage < totalPages : collegesArray.length === LIMIT;
                setHasMore(newHasMore);
                hasMoreRef.current = newHasMore;
            } else {
                setHasMore(false);
                hasMoreRef.current = false;
            }
        } catch (error) {
            console.error('Error fetching colleges:', error);
        } finally {
            loadingRef.current = false;
            setLoading(false);
        }
    }, [state, programme, branch]);

    const handleObserver = useCallback((entries) => {
        const target = entries[0];
        if (target.isIntersecting && hasMoreRef.current && !loadingRef.current) {
            handleSubmit(null, true);
        }
    }, [handleSubmit]);

    useEffect(() => {
        if (!hasMoreRef.current || !loader.current) return;

        const option = {
            root: null,
            rootMargin: "200px",
            threshold: 0.25
        };
        const observer = new IntersectionObserver(handleObserver, option);
        observer.observe(loader.current);

        return () => {
            if (loader.current) observer.unobserve(loader.current);
        }
    }, [handleObserver]);

    useEffect(() => {
        handleSubmit();
    }, []);

    const handleViewDetails = async (college) => {
        setSelectedCollege(college);
        setModalOpen(true);
        setDetailsError('');
        setCollegePrograms([]);

        if (!college?.collegeCode) {
            setDetailsError('College code is not available');
            return;
        }

        setDetailsLoading(true);
        try {
            const response = await axios.get(`/api/v1/front/colleges/code/${encodeURIComponent(college.collegeCode)}/programs`);
            if (response.data?.status === 200 && response.data?.data?.programs) {
                setCollegePrograms(response.data.data.programs);
            } else {
                setCollegePrograms([]);
                setDetailsError(response.data?.message || 'No programme details available');
            }
        } catch (error) {
            console.error('Error fetching college program details:', error);
            setCollegePrograms([]);
            setDetailsError('Failed to load programme details.');
        } finally {
            setDetailsLoading(false);
        }
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedCollege(null);
        setCollegePrograms([]);
        setDetailsError('');
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        maxHeight: '80vh',
        overflow: 'auto',
        bgcolor: 'background.paper',
        border: '2px solid #042e2e',
        borderRadius: '8px',
        boxShadow: 24,
        p: 4,
    };

    // console.log(branch)

    const NextStep = async () => {

        if (a.length >= 5) {
            const res = await fetch('/choice-filling', {
                method: "POST",
                headers: {
                    "Content-Type": 'application/json'
                },
                body: JSON.stringify({ collegeName: a, collegeCode: b, programme: c, state: d, seat: e, branch: f })
            })
            const data = await res.json();
            if (!data) {
                // console.log("Please try again after some time")
                alert('Please try again after some time')
            }
            else {
                // console.log("Your college has been added sucessfully")
                alert('Your college has been added sucessfully')
                Navigate('/')

            }
        }
        else {
            alert('please add atleast 25 colleges')
        }
    }



    // *******************thapaaaaaaaa*************
    const [a, setA] = useState([])
    const [b, setB] = useState([])
    const [c, setC] = useState([])
    const [d, setD] = useState([])
    const [e, setE] = useState([])
    const [f, setF] = useState([])
    const collegeChoiceHandle = (collegeName, collegeCode, program, state, seat, branch) => {
        const arr = []
        const index = a.indexOf(collegeName)
        arr.push(index)
        //    console.log(a[arr])
        const branchArr = []
        const branchIndex = f.indexOf(branch)
        branchArr.push(branchIndex)
        //    console.log(f[branchArr])
        if (a[arr] == undefined || f[branchArr] == undefined) {
            setA([...a, collegeName])
            setB([...b, collegeCode])
            setC([...c, program])
            setD([...d, state])
            setE([...e, seat])
            setF([...f, branch])
        }
        else {
            alert("This college has been already exist")
        }
    }
    // console.log(a)
    // console.log(b)
    // console.log(c)
    // console.log(d)
    // console.log(e)
    const removeCollege = (idx) => {
        // console.log(idx)
        setA((e) => {
            return e.filter((elem, index) => {
                return index !== idx
            })
        })
        setB((e) => {
            return e.filter((elem, index) => {
                return index !== idx
            })
        })
        setC((e) => {
            return e.filter((elem, index) => {
                return index !== idx
            })
        })
        setD((e) => {
            return e.filter((elem, index) => {
                return index !== idx
            })
        })
        setE((e) => {
            return e.filter((elem, index) => {
                return index !== idx
            })
        })
        setF((f) => {
            return f.filter((elem, index) => {
                return index !== idx
            })
        })

    }
    // **************************  check autohorization *****************************
    const allDataStudent = async () => {
        fetch('/students-data')
            .then(response => response.json())
            .then(data => {
                //   console.log(data)
                // setAllData(data)
                if (data.collegeChoiceFilling.length != 0) {
                    // Navigate('/document-upload')
                }
            })
            .catch(error => {
                // console.log(error)
            })
    }

    return (
        <>
            <College>
                {/* <AppSidebar /> */}
                <div className="">
                    {/* <AppHeader /> */}
                    <div className="body flex-grow-1 px-3">
                        <div style={{ width: '100%', height: '200vh' }} className="studentDashboardContainer">
                            <div className='collegeSearch'>
                                <div className='clgsearch'>
                                    <div>
                                        <FormControl sx={{ m: 1, minWidth: 250 }} size="small">
                                            <InputLabel style={{ fontWeight: 'bold' }} id="demo-select-small">State</InputLabel>
                                            <Select
                                                labelId="demo-select-small"
                                                id="demo-select-small"
                                                value={state}
                                                label="State"
                                                style={{ backgroundColor: 'white' }}
                                                onChange={(e) => setState(e.target.value)}
                                            >
                                                {/* <MenuItem value="">
                                                <em>ALL</em>
                                            </MenuItem> */}
                                                <MenuItem value=" " >All States</MenuItem>
                                                {indianStates.map((s) => (
                                                    <MenuItem key={s} value={s}>
                                                        {s}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div>
                                        <FormControl sx={{ m: 1, minWidth: 250 }} size="small">
                                            <InputLabel style={{ fontWeight: 'bold' }} id="demo-select-small">Programme</InputLabel>
                                            <Select
                                                labelId="demo-select-small"
                                                id="demo-select-small"
                                                value={programme}
                                                label="Programme"
                                                style={{ backgroundColor: 'white' }}
                                                onChange={(e) => setProgramme(e.target.value)}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                {programmes.map((prog) => (
                                                    <MenuItem key={prog} value={prog}>
                                                        {prog}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div>
                                        {branches.length > 0 && (
                                            <FormControl sx={{ m: 1, minWidth: 250 }} size="small">
                                                <InputLabel style={{ fontWeight: 'bold' }} id="branch-select-label">Branch</InputLabel>
                                                <Select
                                                    labelId="branch-select-label"
                                                    id="branch-select"
                                                    value={branch}
                                                    label="Branch"
                                                    style={{ backgroundColor: 'white' }}
                                                    onChange={(e) => setBranch(e.target.value)}
                                                >
                                                    <MenuItem value="">
                                                        <em>All Branches</em>
                                                    </MenuItem>
                                                    {branches.map((b) => (
                                                        <MenuItem key={b._id} value={b.name}>
                                                            {b.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        )}
                                    </div>
                                    <div>
                                        <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
                                            <Button disabled={loading} onClick={(e) => handleSubmit(e, false)} style={{ backgroundColor: '#042e2e', color: 'white' }} variant="contained" component="span">
                                                {loading && !collegeData.length ? 'Searching...' : 'Search'}
                                            </Button>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                            <div className=' mt-5' style={{ width: '100%' }}>
                                {collegeData.length == 0 ? <></> :
                                    <table className="table" style={{ backgroundColor: 'white', borderRadius: '5px', width: '100%' }}>
                                        <thead className="thead-dark">
                                            <tr style={{ fontSize: '0.9rem' }}>
                                                <th scope="col">#</th>
                                                <th scope="col">College Name</th>
                                                <th scope="col">College Code</th>
                                                <th scope="col">State</th>
                                                <th scope="col">Programme</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                Array.isArray(collegeData) && collegeData.flatMap((college, cIdx) => {
                                                    const uniquePrograms = Array.from(new Set(college.programNames || []));
                                                    return uniquePrograms.map((programName, pIdx) => ({
                                                        programName,
                                                        collegeName: college.collegeName,
                                                        collegeCode: college.collegeCode,
                                                        state: college.state,
                                                        collegeObj: college,
                                                        globalIdx: `${cIdx}-${pIdx}`
                                                    }));
                                                }).filter(item => !programme || item.programName === programme)
                                                    .map((item, index) => {
                                                        return (
                                                            <tr key={item.globalIdx} style={{ fontSize: '0.8rem' }}>
                                                                <td>{index + 1}</td>
                                                                <td style={{ fontWeight: 'bold', color: '#042e2e' }}>{item.collegeName}</td>
                                                                <td>{item.collegeCode}</td>
                                                                <td>{item.state}</td>
                                                                <td>{item.programName}</td>
                                                                <td>
                                                                    <button
                                                                        onClick={() => handleViewDetails(item.collegeObj)}
                                                                        style={{
                                                                            padding: '5px 10px',
                                                                            backgroundColor: '#042e2e',
                                                                            color: 'white',
                                                                            border: 'none',
                                                                            borderRadius: '4px',
                                                                            cursor: 'pointer',
                                                                            fontSize: '0.75rem'
                                                                        }}
                                                                    >
                                                                        View Details
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                            }
                                        </tbody>
                                    </table>
                                }
                                <div ref={loader} style={{ height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    {loading && collegeData.length > 0 && <p style={{ color: '#042e2e', fontWeight: 'bold' }}>Loading more colleges...</p>}
                                    {!hasMore && collegeData.length > 0 && <p style={{ color: 'gray' }}>No more colleges to show</p>}
                                </div>


                            </div>
                        </div>
                    </div>
                    {/* <AppFooter /> */}
                </div>
            </College>

            <Modal
                open={modalOpen}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h2 style={{ margin: 0, color: '#042e2e' }}>
                            {selectedCollege?.collegeName}
                        </h2>
                        <button
                            onClick={handleModalClose}
                            style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                fontSize: '24px',
                                cursor: 'pointer',
                                color: '#042e2e'
                            }}
                        >
                            ×
                        </button>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <p><strong>College Code:</strong> {selectedCollege?.collegeCode}</p>
                        <p><strong>State:</strong> {selectedCollege?.state}</p>
                    </div>

                    <div>
                        <h4 style={{ color: '#042e2e', marginBottom: '10px' }}>All Available Programmes:</h4>
                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {detailsLoading ? (
                                <p>Loading programme details...</p>
                            ) : detailsError ? (
                                <p style={{ color: 'red' }}>{detailsError}</p>
                            ) : collegePrograms.length === 0 ? (
                                <p>No programme details available.</p>
                            ) : (
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#f0f0f0', borderBottom: '2px solid #042e2e' }}>
                                            <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>#</th>
                                            <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Programme</th>
                                            <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Branch Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {collegePrograms.map((program, idx) => (
                                            <tr key={`${program.branchName}-${idx}`} style={{ borderBottom: '1px solid #ddd' }}>
                                                <td style={{ padding: '6px' }}>{idx + 1}</td>
                                                <td style={{ padding: '6px' }}>{program.branchType || '-'}</td>
                                                <td style={{ padding: '4px' }}>{program.branchName || ''}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default CollegeListss